var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_82941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21V16H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.99891V16H0V0Z",
    fill: "#002654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0011 0H21V16H14.0011V0Z",
    fill: "#CE1126"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_82941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFrance);
export default __webpack_public_path__ + "static/media/ic-france.1185bc841283b46a0c90a77d39007385.svg";
export { ForwardRef as ReactComponent };